module.exports = __webpack_public_path__ + "assets/sounds/filling-inbox.mp3";